module.exports = __webpack_public_path__ + "static/media/2.0067e7bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.jpg
// module id = 240
// module chunks = 1